import * as React from 'react';
import { Button } from 'reactstrap';
import { Svg } from '../shared/Svg';

interface IMetricProps {
  color: string;
  label: string;
  metric: number;
  src: string;
  status: string;
}


export const Metric: React.SFC<IMetricProps> = (props) => {
  const { color, label, metric, src, status } = props;
  return (
    <Button
      className={`d-flex justify-content-center align-items-center text-${color} text-left bg-white m-2 border-0`}
    >
      <Svg width={48} fill={color} src={src} className='mr-2' />
      <span className='mr-3' style={{ fontSize: '48px' }}>
        {metric}
      </span>
      <span className='text-nowrap'>
        {label}
        <br />
        <span className='text-warning'>{status}</span>
      </span>
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Metric.tsx